
import { createStore } from 'vuex'
import { setCookie, removeCookie } from '../composables/auth'
import { login, GetCurrentUser } from "../http/login";
import { ElMessage } from "element-plus";
import router from "../router/index";

// 创建一个新的 store 实例
const store = createStore({
  state() {
    return {
      user: {}
    }
  },
  mutations: {
    SET_USERINFO(state, user) {
      state.user = user
    }
  },
  actions: {
    login({ commit }, { LoginName, LoginPassword }) {
      console.log(LoginName);
      console.log(LoginPassword);
      return new Promise((resolve, reject) => {
        login({ LoginName, LoginPassword })
          .then(res => {
            if (res.IsSuccess) {
              setCookie("userToken", res.Token)
              commit("SET_USERINFO", res.Result)
            }
            resolve(res)
          }).catch(err => reject(err))
      })
    },
    getCurrentUser({ commit }) {
      return new Promise((resolve, reject) => {
        GetCurrentUser()
          .then(res => {
            if (res.IsSuccess) {
              commit("SET_USERINFO", res.Result)
            } else {
              removeCookie("userToken");
              ElMessage({
                message: res.ErrorMessage,
                type: "warning",
              });
              router.push({
                path: "/login"
              });
            }
            resolve(res)
          }).catch(err => reject(err))
      })
    },
  }
})


export default store